import { ApiServiceInterface } from './service.interface';
import { HttpApiFactory } from '../../module/http/api.factory';

const apiService = HttpApiFactory();

export function ApiService(): ApiServiceInterface {
  return apiService;
}
